const CATEGORY_ITEMS = [
  "Technology",
  "SaaS",
  "Finance",
  "Health",
  "Crypto",
  "Real Estate",
  "E-commerce",
  "Digital Marketing",
  "Business",
];

const CUSTOM_SLUGS = {
  Technology: "technology-guest-posting",
  SaaS: "saas-guest-posting",
  Finance: "finance-guest-posting",
  Health: "health-guest-posting",
  Crypto: "crypto-guest-posting",
  "Real Estate": "real-estate-guest-posting",
  "E-commerce": "e-commerce-guest-posting",
  "Digital Marketing": "digital-marketing-guest-posting",
  Business: "business-guest-posting",
};

const ROUTE_SLUGS = {
  Technology: "technology",
  SaaS: "saas",
  Finance: "finance",
  Health: "health",
  Crypto: "crypto",
  "Real Estate": "real-estate",
  "E-commerce": "e-commerce",
  "Digital Marketing": "digital-marketing",
  Business: "business",
};

const toSlug = (label) =>
  label
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[()]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const allCategoryItems = CATEGORY_ITEMS.map((label) => ({
  label,
  slug: CUSTOM_SLUGS[label] || `${toSlug(label)}-guest-posting`,
  routeSlug: ROUTE_SLUGS[label] || toSlug(label),
  href: `/category/${ROUTE_SLUGS[label] || toSlug(label)}`,
}));

const categorySlugToLabel = allCategoryItems.reduce((acc, item) => {
  acc[item.slug] = item.label;
  acc[item.routeSlug] = item.label;
  if (item.routeSlug === "technology") {
    acc["technolog"] = item.label;
  }
  return acc;
}, {});

const defaultHowSteps = [
  {
    title: "Take Control or Let Us Drive",
    text: "Choose your own filters or let our team shortlist the best sites for your campaign goals.",
  },
  {
    title: "We Get to Work",
    text: "We handle outreach, approvals, and placement planning with a focus on contextual relevance and authority.",
  },
  {
    title: "Get Production-Ready Content",
    text: "Receive quality guest posts and live links with fast turnaround and complete reporting.",
  },
];

const defaultFaq = [
  {
    question: "What are guest posting sites in [CATEGORY]?",
    answer:
      "Guest posting sites in [CATEGORY_LOWER] are relevant blogs and publications where your content can be published with contextual backlinks.",
  },
  {
    question: "How do you select websites?",
    answer:
      "We select sites using manual vetting for niche relevance, quality content, traffic consistency, and editorial standards.",
  },
  {
    question: "What metrics do you consider?",
    answer:
      "We review authority (DA/DR), traffic, topical alignment, spam indicators, and link placement quality before recommending any website.",
  },
  {
    question: "How long does it take to see results?",
    answer:
      "You may see referral traffic soon after publishing. SEO impact typically improves over a few weeks to months based on competition and site strength.",
  },
  {
    question: "Can I approve websites before publishing?",
    answer:
      "Yes. We can share shortlisted websites for your review so placements stay aligned with your goals and brand standards.",
  },
  {
    question: "Do you provide do-follow backlinks?",
    answer:
      "Yes, we focus on relevant editorial placements and natural backlink profiles, including do-follow opportunities where available.",
  },
];

const categoryPageContentByLabel = {
  Technology: {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/technology-category-bannerimg.jpg`,
    heroText:
      "Build stronger visibility in the technology niche with high-quality placements on trusted websites. We secure contextual backlinks that support rankings, trust, and qualified growth for your brand.",
    ctaText: "Get Guest Posts in Technology",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "index.hr", age: "15 Years", traffic: "93.9M", backlinks: "108K", niche: "Technology, News & Media", metrics: "DA 77 / DR 74, SS 1%" },
      { name: "kongotech.org", age: "8 Years", traffic: "178.6K", backlinks: "35", niche: "Technology, Digital Marketing", metrics: "DA 52 / DR 71, SS 2%" },
      { name: "redeepseek.com", age: "5 Years", traffic: "3K", backlinks: "4", niche: "SaaS, Technology", metrics: "DA 41 / DR 70, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "They are technology-focused blogs and editorial websites where your content can be published with relevant contextual backlinks.",
      },
      {
        question: "How do you select technology websites?",
        answer:
          "We shortlist sites based on topical match (software, AI, SaaS, gadgets), traffic consistency, editorial quality, and domain authority.",
      },
      {
        question: "What metrics do you consider for technology campaigns?",
        answer:
          "We evaluate DA/DR, organic traffic quality, spam indicators, indexing health, and link placement context before finalizing placements.",
      },
    ],
  },
  SaaS: {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/content-writing-bgimg.jpg`,
    heroText:
      "Scale SaaS visibility with niche-relevant guest posting placements that build authority and drive qualified sign-up traffic.",
    ctaText: "Get Guest Posts in SaaS",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "saasreviewhub.com", age: "9 Years", traffic: "412K", backlinks: "51K", niche: "SaaS, Software", metrics: "DA 64 / DR 72, SS 2%" },
      { name: "growthstackblog.com", age: "7 Years", traffic: "236K", backlinks: "19K", niche: "SaaS, Marketing", metrics: "DA 58 / DR 69, SS 2%" },
      { name: "redeepseek.com", age: "5 Years", traffic: "3K", backlinks: "4", niche: "SaaS, Digital Marketing", metrics: "DA 41 / DR 70, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "SaaS guest posting sites are software and growth publications where B2B buyers discover tools, workflows, and product comparisons.",
      },
      {
        question: "How do you select SaaS websites?",
        answer:
          "We prioritize sites with strong product-led audiences, relevant SaaS categories, and real organic visibility for commercial-intent keywords.",
      },
      {
        question: "What metrics do you consider for SaaS guest posts?",
        answer:
          "Along with DA/DR and traffic, we check keyword intent fit, content freshness, and whether the site ranks for SaaS-related buying topics.",
      },
    ],
  },
  Finance: {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/paid-citations-bgimg.jpg`,
    heroText:
      "Increase trust in the finance niche through editorial guest posts on credible publications with relevant audiences.",
    ctaText: "Get Guest Posts in Finance",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "bankrateinsights.net", age: "10 Years", traffic: "1.1M", backlinks: "73K", niche: "Finance, Banking", metrics: "DA 68 / DR 76, SS 1%" },
      { name: "moneytrendtoday.com", age: "6 Years", traffic: "290K", backlinks: "21K", niche: "Finance, Business", metrics: "DA 55 / DR 66, SS 2%" },
      { name: "wealthwireblog.com", age: "4 Years", traffic: "125K", backlinks: "9K", niche: "Finance, Investing", metrics: "DA 48 / DR 60, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "Finance guest posting sites are publications covering banking, investing, insurance, and money management with trustworthy editorial standards.",
      },
      {
        question: "How do you select finance websites?",
        answer:
          "We choose websites with authority in finance topics, clean compliance-friendly content, and strong user trust signals.",
      },
      {
        question: "What metrics do you consider for finance placements?",
        answer:
          "We assess domain trust, topical relevance, traffic quality, spam score, and placement context to protect brand credibility.",
      },
    ],
  },
  Health: {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/contact-bgimg.jpg`,
    heroText:
      "Strengthen healthcare and wellness visibility with high-quality guest posts on trusted health-focused websites.",
    ctaText: "Get Guest Posts in Health",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "healthinsiderdaily.com", age: "11 Years", traffic: "820K", backlinks: "62K", niche: "Health, Wellness", metrics: "DA 66 / DR 74, SS 1%" },
      { name: "fitlifestylejournal.com", age: "7 Years", traffic: "340K", backlinks: "26K", niche: "Fitness, Lifestyle", metrics: "DA 57 / DR 67, SS 2%" },
      { name: "caretipsonline.org", age: "5 Years", traffic: "118K", backlinks: "11K", niche: "Healthcare", metrics: "DA 49 / DR 61, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "Health guest posting sites are wellness and medical-adjacent publications where informative, audience-first content can earn trusted links.",
      },
      {
        question: "How do you select health websites?",
        answer:
          "We evaluate editorial credibility, content quality, audience relevance, and topic fit to ensure safe and useful placements.",
      },
      {
        question: "What metrics do you consider in health outreach?",
        answer:
          "We check authority, traffic consistency, spam profile, and publication quality, while ensuring links are naturally placed in relevant content.",
      },
    ],
  },
  Crypto: {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/blog-bgimg.jpg`,
    heroText:
      "Build authority in crypto with contextual placements on blockchain and digital asset publications that your audience reads.",
    ctaText: "Get Guest Posts in Crypto",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "cryptowireinsights.com", age: "8 Years", traffic: "512K", backlinks: "44K", niche: "Crypto, Blockchain", metrics: "DA 61 / DR 70, SS 2%" },
      { name: "defiweeklynews.com", age: "6 Years", traffic: "260K", backlinks: "18K", niche: "DeFi, Web3", metrics: "DA 54 / DR 65, SS 2%" },
      { name: "tokenmarketjournal.com", age: "4 Years", traffic: "97K", backlinks: "8K", niche: "Crypto Markets", metrics: "DA 46 / DR 58, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "Crypto guest posting sites are blockchain, DeFi, and digital asset publications where your brand can earn niche-relevant exposure and links.",
      },
      {
        question: "How do you select crypto websites?",
        answer:
          "We filter for active crypto audiences, authentic editorial standards, and stable search visibility across blockchain-related topics.",
      },
      {
        question: "What metrics do you consider for crypto guest posting?",
        answer:
          "We review DR/DA, keyword footprint, trend stability, spam risk, and backlink context to maintain long-term value.",
      },
    ],
  },
  "Real Estate": {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/privacy-policy-bgimg.jpg`,
    heroText:
      "Generate real estate leads with niche guest posting campaigns that increase search presence and local authority.",
    ctaText: "Get Guest Posts in Real Estate",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "propertyinsightshub.com", age: "12 Years", traffic: "690K", backlinks: "58K", niche: "Real Estate", metrics: "DA 63 / DR 71, SS 1%" },
      { name: "homelistingblog.com", age: "8 Years", traffic: "305K", backlinks: "24K", niche: "Housing, Property", metrics: "DA 56 / DR 66, SS 2%" },
      { name: "realtorsdigest.co", age: "5 Years", traffic: "132K", backlinks: "10K", niche: "Real Estate, Business", metrics: "DA 50 / DR 62, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "Real estate guest posting sites are property, housing, and investment publications where target buyers and sellers consume market content.",
      },
      {
        question: "How do you select real estate websites?",
        answer:
          "We select websites with local and national property relevance, strong editorial quality, and consistent traffic from real estate searches.",
      },
      {
        question: "What metrics do you consider in real estate placements?",
        answer:
          "We look at authority, geo relevance, keyword rankings, spam profile, and link placement quality to support long-term lead visibility.",
      },
    ],
  },
  "E-commerce": {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/link-insertion-bgimg.jpg`,
    heroText:
      "Drive e-commerce growth with strategic guest posts that improve rankings for product and category intent keywords.",
    ctaText: "Get Guest Posts in E-commerce",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "ecommercetrendsnow.com", age: "9 Years", traffic: "470K", backlinks: "39K", niche: "E-commerce", metrics: "DA 60 / DR 69, SS 2%" },
      { name: "storegrowthacademy.com", age: "7 Years", traffic: "225K", backlinks: "16K", niche: "E-commerce, Marketing", metrics: "DA 53 / DR 64, SS 2%" },
      { name: "cartconversiontips.com", age: "4 Years", traffic: "88K", backlinks: "7K", niche: "Online Retail", metrics: "DA 45 / DR 57, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "E-commerce guest posting sites are online retail and DTC-focused publications where shoppers and store owners discover growth strategies.",
      },
      {
        question: "How do you select e-commerce websites?",
        answer:
          "We choose publications with strong relevance to product discovery, conversion, retention, and store operations.",
      },
      {
        question: "What metrics do you consider for e-commerce links?",
        answer:
          "We evaluate authority, buyer-intent keyword visibility, traffic quality, spam score, and contextual fit of anchor placements.",
      },
    ],
  },
  "Digital Marketing": {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/digital-marketing-partner-banner.jpg`,
    heroText:
      "Boost digital marketing visibility with placements on authority blogs that send both ranking signals and referral traffic.",
    ctaText: "Get Guest Posts in Digital Marketing",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "index.hr", age: "15 Years", traffic: "93.9M", backlinks: "108K", niche: "Digital Marketing & Advertising", metrics: "DA 77 / DR 74, SS 1%" },
      { name: "kongotech.org", age: "8 Years", traffic: "178.6K", backlinks: "35", niche: "Digital Marketing, Technology", metrics: "DA 52 / DR 71, SS 2%" },
      { name: "growthsignalsmedia.com", age: "6 Years", traffic: "240K", backlinks: "14K", niche: "SEO, Content Marketing", metrics: "DA 55 / DR 65, SS 2%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "Digital marketing guest posting sites are SEO, PPC, content, and growth blogs where marketers look for practical insights and tools.",
      },
      {
        question: "How do you select digital marketing websites?",
        answer:
          "We prioritize sites with topic overlap, editorial quality, and strong search visibility in marketing terms.",
      },
      {
        question: "What metrics do you consider for marketing campaigns?",
        answer:
          "We analyze domain authority, organic traffic profile, topical clusters, spam risk, and backlink context for durable SEO value.",
      },
    ],
  },
  Business: {
    heroImage: `${process.env.REACT_APP_HOME_URL}/assets/img/web-design-development-bannerimg.jpg`,
    heroText:
      "Establish business authority through editorial guest posts on trusted sites where founders and decision-makers are active.",
    ctaText: "Get Guest Posts in Business",
    domainsExtraText:
      "Lorem ipsum dolor sit amet for [CATEGORY_LOWER], consectetur adipiscing elit. Integer posuere nibh at tristique tristique.",
    domainRows: [
      { name: "bizinsiderjournal.com", age: "11 Years", traffic: "760K", backlinks: "61K", niche: "Business, Startups", metrics: "DA 65 / DR 73, SS 1%" },
      { name: "leadersdigest.net", age: "8 Years", traffic: "330K", backlinks: "22K", niche: "Entrepreneurship", metrics: "DA 57 / DR 67, SS 2%" },
      { name: "strategygrowthblog.org", age: "5 Years", traffic: "140K", backlinks: "9K", niche: "Business Growth", metrics: "DA 50 / DR 61, SS 3%" },
    ],
    faq: [
      {
        question: "What are guest posting sites in [CATEGORY]?",
        answer:
          "Business guest posting sites are leadership, startup, and strategy publications where decision-makers engage with industry content.",
      },
      {
        question: "How do you select business websites?",
        answer:
          "We select business publications based on audience quality, relevance to your niche, editorial trust, and sustainable SEO performance.",
      },
      {
        question: "What metrics do you consider for business guest posts?",
        answer:
          "We consider authority, audience relevance, traffic reliability, spam checks, and natural contextual link placement.",
      },
    ],
  },
};

export {
  CATEGORY_ITEMS,
  allCategoryItems,
  categorySlugToLabel,
  categoryPageContentByLabel,
  defaultHowSteps,
  defaultFaq,
};
